export const ONE_SECOND_IN_MILLIS = 1000;
export const ONE_MINUTE_IN_MILLIS = ONE_SECOND_IN_MILLIS * 60;
export const FIVE_MINUTES_IN_MILLIS = ONE_MINUTE_IN_MILLIS * 5;
